/**
 * ProgramController
 * Responsible for Processing front end Programs
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

angular.module('flsControllers').controller('ProgramController', ['$scope', 'Program', function($scope, Program){

    // Define default Program Object
    // ...maybe this needs to be a factory?
    var defaultModel = {
        programType:{},
        primaryBrand:{},
        primaryPresentation:{},
        presentations:[],
        presentation_topics:[],
        speakers:[],
    };

    // for #Create this would be {}
    // for #Edit this would be loaded Resource
    $scope.program = defaultModel

    // Set loading state to false
    $scope.loading = false

    // Init Secondary Presentations
    $scope.secondaryPresentations = []

    /**
     * Reset the Entity
     *
     * @return Void
     */
    $scope.reset = function() {
      // Re-map the Program to default
      $scope.program = defaultModel
      // Populate the secondary Presentations with Program presentations
      $scope.secondaryPresentations = defaultModel.presentations.map(function(item){return item["id"];});
    }

    /**
     * Init the Controller by fetching the properties of the Program
     *
     * @param  object profileId
     * @return Void
     */
    $scope.init = function(id){
        if (!id) return;
        // Set Loading to true
        $scope.loading = $scope.loading || true;
        // Load the Program
        Program.get({id:id}, function(resource){
            if(resource){
                // Rewrite default property
                defaultModel = resource.data || defaultModel
                // Set Loading to false
                $scope.loading = false;
                // reset the Program
                $scope.reset()
                // Flash a message
                $.publish('resource.success', 'Program Loaded');
            } else {
                /*display an error maybe? */
            };
        });
    }

    /**
     * Allow iterating through the list of values
     *
     * @param int start
     * @param int end
     */
    $scope.range = function(start, end) {
      var result = [];
      for (var i = start; i <= end; i++) {
        result.push(i);
      }
      return result;
    };

    /**
     * Compute Speaker Bureaud
     *
     * @type {Array}
     */
    $scope.speakerBureaus = function(){

        var speakerBureaus = _.isUndefined(this.program.primaryBrand) ? [] : this.program.primaryBrand.speaker_bureaus;

        return _.filter(speakerBureaus, function(o) {
            return o.is_valid || o.is_future;
        });
    }

    /**
     * List all Program Speakers
     *
     * @type {Array}
     */
    $scope.speakers = function(){
        return _.get(this, 'program.speakers', []);
    }
}]);
